import * as cart from '../types/cart'

import {
    createShoppingCart,
    updateShoppingCart,
    getAddress,
    getFee,
    agentDate,
    getShoppingCart,
    pollingDocumentCheck
} from '../../api/cart'

import { aleloPodGroups } from 'constants/pod-groups'
import { aleloTudoGroups } from 'constants/alelo-tudo-groups'
import {
    closeModalCnpj,
    setLoading,
    removeLoading,
    openModalLead,
    setNewCompany,
    setOldCompany,
    setCnpjError,
    reset as resetLead,
    openModalRegistrationIrregularity,
    openModalPollingError
} from './lead'
import { reset as resetRequest, setRequestsLoading } from './request'
import { reset as resetHome } from './home'
import { getCompany, getSpokesman } from '../../storage'
import { polling } from '../../utils/polling'
import StringFormat from 'utils/StringFormat'

export const openModal = () => ({
    type: cart.OPEN_MODAL
})

export const toggleModal = () => ({
    type: cart.TOGGLE_MODAL
})

export const closeModal = () => ({
    type: cart.CLOSE_MODAL
})

export const addEditProduct = (product) => ({
    type: cart.ADD_EDIT_PRODUCT,
    payload: { product: { ...product, fee: [] } }
})

export const removeProduct = (id) => ({
    type: cart.REMOVE_PRODUCT,
    payload: { id }
})

export const setGroupItemValue = (productIndex, itemType, value) => ({
    type: cart.SET_GROUP_ITEM_VALUE,
    payload: { productIndex, itemType, value }
})

export const setGroupItemQnt = (productIndex, itemType, qnt) => ({
    type: cart.SET_GROUP_ITEM_QNT,
    payload: { productIndex, itemType, qnt }
})

export const setValueProduct = (index, value) => ({
    type: cart.SET_VALUE_PRODUCT,
    payload: { index, value }
})

export const setQntProduct = (index, qnt) => ({
    type: cart.SET_QNT_PRODUCT,
    payload: { index, qnt }
})

export const startPostalCodeSearch = () => ({
    type: cart.START_POSTAL_CODE_SEARCH
})

export const setPostalCodeError = (error) => ({
    type: cart.SET_POSTAL_CODE_ERROR,
    payload: { error }
})

export const setCompanyAddresses = ({
    postalCode,
    state,
    city,
    district,
    street
}) => ({
    type: cart.SET_COMPANY_ADDRESSES,
    payload: { postalCode, state, city, district, street }
})

export const createCart = (payload, products) => (dispatch, getState) => {
    dispatch(setLoading())
    return createShoppingCart(payload)
        .then((response) => {
            const data = response.data
            checkCNPJ(data, products, payload, dispatch, getState)
        })
        .catch(() => {
            dispatch(removeLoading())
            dispatch(setCnpjError())
        })
}

export const validateCNPJ = async (cartId) => {
    let check = await polling(() => pollingDocumentCheck(cartId), {
        minInterval: 1000,
        timeout: 30000
    })

    return {
        valid: check.unavailableProducts.length === 0,
        unavailableProducts: check.unavailableProducts
    }
}

export const checkCNPJ = async (
    data,
    products,
    payload,
    dispatch,
    getState
) => {
    if (data.hasExistingContracts) {
        dispatch(setCompanyType(data))
        return
    }

    let documentCheck
    try {
        documentCheck = await validateCNPJ(data.id)
    } catch (err) {
        console.error('Não foi possivel validar o CNPJ em tempo hábil.')
        dispatch(openModalPollingError())
        dispatch(closeModalCnpj())
        dispatch(removeLoading())
        dispatch(setCnpjError())
        return
    }

    const unavailableProductCodes = documentCheck.unavailableProducts.map(
        (unavailable) => StringFormat.renderUnavaibleProductCode(unavailable)
    )
    const hasOnlyUnavailableProducts = products.every((p) =>
        unavailableProductCodes.includes(p.id)
    )

    const removedProducts = products.filter((p) =>
        unavailableProductCodes.includes(p.id)
    )

    dispatch(
        setDocumentVerification(documentCheck.valid, unavailableProductCodes)
    )
    if (documentCheck.valid === false && hasOnlyUnavailableProducts) {
        dispatch(removeLoading())
        dispatch(closeModalCnpj())
        dispatch(openModalRegistrationIrregularity(removedProducts))
        return
    }

    dispatch(setCompanyType(data))
    const state = getState()

    if (state.cart.id) {
        updateShoppingCart(state.cart.id, {
            ...state.cart,
            bank: state.bank
        })
    }
}

export const setCompanyType = (data) => (dispatch) => {
    dispatch(closeModalCnpj())
    if (!data.hasExistingContracts) {
        dispatch(setNewCompany())
        getSpokesman(dispatch)
        getCompany(dispatch)
    } else {
        dispatch(setOldCompany())
    }
    dispatch(setCartData(data.id, data.code, data.status, data.max_card_pme))
    dispatch(openModalLead())
    dispatch(removeLoading())
}

const fillAddress = (billingAddress) => ({
    postalCode: billingAddress.postalCode || '',
    state: billingAddress.state || '',
    city: billingAddress.city || '',
    street: billingAddress.street || '',
    additionalInfo: billingAddress.additionalInfo || '',
    neighborhood: billingAddress.neighborhood || '',
    number: billingAddress.number || ''
})

const fillProduct = (product) => ({
    id: parseInt(product.code),
    loading: false,
    value: product.paymentValue.toFixed(2),
    qnt: product.amount,
    total: product.amount * product.paymentValue,
    fees: product.fees
        ? product.fees.map((feeData) => ({
              feeCode: feeData.code,
              fee: feeData.value,
              valueType: feeData.valueType
          }))
        : 0.0
})

export const fillShoppingCart = (cartId) => (dispatch) => {
    return getShoppingCart(cartId).then((response) => {
        const data = response.data

        let bureauData = {}

        if (data.company) {
            if (data.company.businessName) {
                bureauData = {
                    name: data.company.businessName
                }
            }

            if (data.company.billingAddress) {
                bureauData = {
                    ...bureauData,
                    deliveryAddress: fillAddress(data.company.billingAddress),
                    billingAddress: fillAddress(data.company.billingAddress)
                }
            }
        }

        if (data.products && data.products.length > 0) {
            let products = data.products.map(fillProduct)
            bureauData = {
                ...bureauData,
                products
            }
            dispatch(fillProducts(products))
        }

        dispatch(fillBureauData(bureauData))

        return bureauData
    })
}

export const fillProducts = (products) => ({
    type: cart.FILL_CART_PRODUCT,
    payload: { products }
})

export const fillBureauData = (data) => ({
    type: cart.FILL_BUREAU_DATA,
    payload: { data }
})

export const updateCart =
    (id, payload, successFn = () => {}, errorFn = () => {}) =>
    () => {
        updateShoppingCart(id, payload)
            .then(() => {
                successFn()
            })
            .catch(() => {
                errorFn()
            })
    }

export const setCompanyDocument = (value) => ({
    type: cart.SET_COMPANY_DOCUMENT,
    value
})

export const setCompanyName = (value) => ({
    type: cart.SET_COMPANY_NAME,
    value
})

export const setCompanyData = (data) => ({
    type: cart.SET_COMPANY_DATA,
    payload: { data }
})

export const setCartData = (id, code, status, maxCard) => ({
    type: cart.SET_CART_DATA,
    id,
    code,
    status,
    maxCard
})

export const setSpokesman = (name, email, phone, doc, birthDate) => ({
    type: cart.SET_SPOKESMAN,
    name,
    email,
    phone,
    doc,
    birthDate
})

export const setSpokesmenData = (
    kind,
    { name, email, phone, documentNumber, birthDate }
) => ({
    type: cart.SET_SPOKESMEN_DATA,
    kind,
    name,
    email,
    phone,
    documentNumber,
    birthDate
})

export const setDocumentVerification = (valid, unavailableProductCodes) => ({
    type: cart.SET_DOCUMENT_VERIFICATION,
    valid,
    unavailableProductCodes
})

export const setTraditionalProductFee = (code, payload) => (dispatch) => {
    dispatch(setTaxa(code, payload))
}

export const addGroupItemToProduct = (productId, item) => (dispatch) => {
    dispatch({
        type: cart.ADD_GROUP_ITEM,
        payload: { ...item },
        code: productId
    })
}

export const getGroupByType = (code, type) => {
    if (!code || !type) {
        return null
    }

    if (code == 700) {
        return aleloPodGroups.find(
            (item) => item.type === type || item.desc === type
        )
    }

    if (code == 900) {
        return aleloTudoGroups.find(
            (item) => item.type === type || item.desc === type
        )
    }
}

export const setPodTudoProductFee =
    (code, groups, productFees) => (dispatch) => {
        dispatch(
            setPodTudoTaxa(code, productFees, {
                ...groups,
                items: groups.items.map((item) => {
                    return {
                        ...item,
                        type: getGroupByType(code, item.type).type
                    }
                })
            })
        )
    }

export const setTotalFee = (payload) => (dispatch) => {
    dispatch(setTotalTaxa(payload))
}

export const setFeeError = () => ({
    type: cart.SET_FEE_ERROR
})

export const getAddressByPostalCode = (postalCode) => (dispatch) => {
    dispatch(startPostalCodeSearch())

    return getAddress(postalCode)
        .then((response) => {
            const data = response.data

            const address = {
                postalCode: data.cep,
                state: data.uf,
                city: data.cityName,
                street: data.streetName,
                district: data.districtName
            }

            dispatch(setCompanyAddresses(address))
        })
        .catch((error) => {
            const address = {
                postalCode: postalCode,
                state: '',
                city: '',
                street: '',
                district: ''
            }

            const status = error.response.status

            if (status === 404) {
                dispatch(setPostalCodeError('CEP não encontrado'))
            } else {
                dispatch(setCompanyAddresses(address))
            }
        })
}

export const updateAllFees = () => (dispatch, getState) => {
    const { bank, cart } = getState()

    dispatch(setRequestsLoading(true))
    saveShoppingCartData(bank, cart)
        .then(() => {
            return getUpdatedShoppingCartData(cart, bank)
        })
        .then((updatedShoppingCartData) => {
            return updateShoppingCartData(
                updatedShoppingCartData.data,
                dispatch
            )
        })
        .catch(() => {
            dispatch(setFeeError())
        })
        .finally(() => {
            dispatch(setRequestsLoading(false))
        })
}

const saveShoppingCartData = (bank, cart) => {
    return updateShoppingCart(cart.id, { ...cart, bank })
}

const getUpdatedShoppingCartData = (cart, bank) => {
    return getFee(cart.id, StringFormat.bankAbbreviation(bank.name))
}

const updateShoppingCartData = (shoppingCartData, dispatch) => {
    shoppingCartData.products.forEach((product) => {
        if (['POD', 'TUDO'].includes(product.productType)) {
            dispatch(
                setPodTudoProductFee(product.code, product.groups, product.fees)
            )
        } else {
            dispatch(setTraditionalProductFee(product.code, product))
        }
    })

    dispatch(setTotalFee(shoppingCartData))
}

export const setPat = (isPat, code) => ({
    type: cart.SET_PAT,
    isPat,
    code
})

export const setTaxa = (code, payload) => ({
    type: cart.SET_FEE,
    payload,
    code
})

export const setPodTudoTaxa = (code, productFees, groups) => ({
    type: cart.SET_POD_TUDO_FEE,
    code,
    productFees,
    groups
})

export const setTotalTaxa = (payload) => ({
    type: cart.SET_TOTAL_FEE,
    payload
})

export const setUpSellFeeTarget = (code) => ({
    type: cart.SET_UP_SELL_FEE_TARGET,
    payload: { code }
})

export const closeUpSellTaxa = () => ({
    type: cart.CLOSE_UP_SELL_FEE
})

export const clearCart = () => ({
    type: cart.CLEAR_CART
})

export const clearCartAndCache = () => (dispatch) => {
    dispatch(clearCart())

    localStorage.removeItem('cart.products')
}

export const addEditProductAndHighlight = (product) => (dispatch) => {
    dispatch(addNewProduct(product))

    setTimeout(() => {
        dispatch(clearNewProduct())
    }, 1500)
}

export const clearNewProduct = () => ({
    type: cart.CLEAR_NEW_PRODUCT
})

export const addNewProduct = (product) => ({
    type: cart.ADD_NEW_PRODUCT,
    payload: { product: { ...product, fee: [] } }
})

export const changePaymentType = (type) => ({
    type: cart.CHANGE_PAYMENT_TYPE,
    payload: { type }
})

export const setContract = (contract) => ({
    type: cart.SET_CONTRACT_DATA,
    payload: { contract }
})

export const setContracts = (contracts) => ({
    type: cart.SET_CONTRACTS,
    payload: { contracts }
})

export const setSpokesmanDocument = (doc) => ({
    type: cart.SET_SPOKESMAN_DOCUMENT,
    doc
})

export const reset = () => ({
    type: cart.RESET
})

export const setRecoveryCart = (data) => ({
    type: cart.SET_RECOVERY_CART,
    payload: { data }
})

export const deniePrivacityTerms = () => (dispatch) => {
    dispatch(closePrivacityTerms())
    sessionStorage.setItem(
        'cart.privacityTermsResponse',
        JSON.stringify({ accept: false })
    )
}

export const closePrivacityTerms = () => ({
    type: cart.CLOSE_PRIVACITY_TERMS
})

export const acceptPrivacityTerms = (datetime) => ({
    type: cart.ACCEPT_PRIVACITY_TERMS,
    payload: { datetime }
})

export const dateAcceptPrivacityTerms = () => (dispatch, getState) => {
    return agentDate()
        .then(() => {
            dispatch(acceptPrivacityTerms(123456749813516))
            const state = getState()
            localStorage.setItem(
                'cart.privacityTermsResponse',
                JSON.stringify(state.cart.cookiesAccepted)
            )
        })
        .catch(() => {
            dispatch(closePrivacityTerms())
        })
}

export const recoveryCart = (products, bank = '') => ({
    type: cart.RECOVERY_CART,
    payload: { products, bank }
})

export const resetAll = () => (dispatch) => {
    dispatch(reset())
    dispatch(resetHome())
    dispatch(resetLead())
    dispatch(resetRequest())
}

export const resetSpokesman = () => ({
    type: cart.RESET_SPOKESMAN
})
